import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/ruby';
import comment from '../../snippets/comment';
import {locales} from '../sampleLocations';
import {CreateShellCommand} from '../../../components/left-col';

const createIntent = (country, reader) => {
  if (reader === 'wpe') {
    const currency = locales[country].currency;
    const pmTypes =
      country === 'CA'
        ? `['card_present', 'interac_present']`
        : `['card_present']`;
    return `
{+create-intent}
post '/create_payment_intent' do
  content_type 'application/json'
  data = JSON.parse(request.body.read)

  # For Terminal payments, the 'payment_method_types' parameter must include
  # 'card_present' and the 'capture_method' must be set to 'manual'
  {span response create-intent}intent{/span} = Stripe::PaymentIntent.create(
    amount: data['amount'],
    currency: '${currency}',
    payment_method_types: ${pmTypes},
    capture_method: 'manual',
  )

  {client_secret: intent.client_secret}.to_json
end
{/create-intent}
`;
  }
};

const createLocation = (country) => {
  const location = locales[country].location;
  const city = location.address.city
    ? `
    city: '${location.address.city}',`
    : '';
  const state = location.address.state
    ? `
    state: '${location.address.state}',`
    : '';
  return `
def create_location
{+create-location}
Stripe::Terminal::Location.create({
  display_name: '${location.displayName}',
  address: {
    line1: '${location.address.line1}',${city}${state}
    country: '${location.address.country}',
    postal_code: '${location.address.postalCode}',
  }
})
{/create-location}
end
`;
};

const homeRoute = `
get "/" do
  redirect '/index.html'
end
`;

export const steps = {
  setup,
  'create-location': {},
  'connection-token-endpoint': {},
  'create-intent': {},
  'capture-intent-endpoint': {},
  'run-server': {
    Component: CreateShellCommand(run),
    body: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.server.ruby.run-server.body',
        defaultMessage: 'Run your Ruby server and go to <a>localhost:4242</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242" target="_blank">
            {str}
          </a>
        ),
      },
    },
  },
};

export default ({
  keys,
  merchant,
  reader,
  platform,
  country,
}) => `require 'sinatra'
{+setup}
require 'stripe'
${comment && comment(merchant, '#')}
Stripe.api_key = '${keys.secret}'
{/setup}

set :static, true
set :port, 4242
${createLocation(country)}
# The ConnectionToken's secret lets you connect to any Stripe Terminal reader
# and take payments with your Stripe account.
# Be sure to authenticate the endpoint for creating connection tokens.
{+connection-token-endpoint}
post '/connection_token' do
  content_type 'application/json'

  {span response connection-token-endpoint}connection_token{/span} = Stripe::Terminal::ConnectionToken.create
  {secret: connection_token.secret}.to_json
end
{/connection-token-endpoint}
${createIntent(country, reader)}
{+capture-intent-endpoint}
post '/capture_payment_intent' do
  data = JSON.parse(request.body.read)

  {span response capture-intent-endpoint}intent{/span} = Stripe::PaymentIntent.capture(
    data['id']
  )

  intent.to_json
end
{/capture-intent-endpoint}
${platform === 'web' ? homeRoute : ''}
`;
